import { render, staticRenderFns } from "./predicted.vue?vue&type=template&id=0d821360&scoped=true"
import script from "./predicted.vue?vue&type=script&lang=js"
export * from "./predicted.vue?vue&type=script&lang=js"
import style0 from "./predicted.vue?vue&type=style&index=0&id=0d821360&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d821360",
  null
  
)

export default component.exports